import { Badge, FlexRow } from '@make-software/cspr-design';
import React from 'react';
import { useTheme } from 'styled-components';
import { Tooltip } from '@block-explorer/ui';
import { useTranslation } from 'react-i18next';

export const X402Badge = () => {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <Tooltip
      tooltipContent={t(
        'This transaction follows the x402 open standard for internet‑native payments and is part of the x402 ecosystem enabling agentic, automated client‑server payments.'
      )}
    >
      <FlexRow gap={3} align={'center'}>
        <Badge
          lineHeight={'xxs'}
          label={'x402'}
          variation={theme.styleguideColors.contentLightBlue}
        />
      </FlexRow>
    </Tooltip>
  );
};
